import React from "react";
import {
  HeartPulse, Smile, Eye, Umbrella, Activity, Shield, LifeBuoy, Package,
  Stethoscope, Pill, BadgeCheck, ShieldCheck,
} from "lucide-react";

const MAP = {
  HeartPulse, Smile, Eye, Umbrella, Activity, Shield, LifeBuoy,
  Stethoscope, Pill, BadgeCheck, ShieldCheck,
};

export function BenefitIcon({ name, className = "w-5 h-5" }) {
  const Icon = MAP[name] || Package;
  return <Icon className={className} />;
}
